var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSideYellowBigger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1441,
    height: 1629,
    viewBox: "0 0 1441 1629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_180299_176854",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1441,
    height: 1629
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6875,
    y: 0.666016,
    width: 1440,
    height: 1628,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_180299_176854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.94 264.603C114.174 42.5846 -26.5001 9.42946 -97.8666 20.6042L-136.313 1467.67L-136.313 2254.17L1472.69 2235.67L1472.69 1420.67L1472.69 1221.17C1425.19 1147.33 1278.28 1226.2 913.189 1141.17C752.189 1103.67 590.644 1032.17 578.188 891.667C544.189 508.167 95.6465 542.126 105.94 264.603Z",
    fill: "#FEE8B1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideYellowBigger);
export default __webpack_public_path__ + "static/media/side-yellow-bigger.57f174f2c2343d098dade73841887fc3.svg";
export { ForwardRef as ReactComponent };